export default __webpack_public_path__ + "static/media/355.98f7c3d8.gif";